module.exports = __webpack_public_path__ + "media/images/athletes/2189-eb4b335f2236b5fb714d43d61792c572.png";